var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleBlueSemafor = function SvgDoubleBlueSemafor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 8,
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#2174FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 4,
    r: 4,
    fill: "#E757FF"
  })));
};
export default SvgDoubleBlueSemafor;